export const USER = {
  item: {
    id: "",
    username: "",
    f: "",
    i: "",
    o: "",
    email: ""
  },
  isLoaded: false,
  isFetching: false
};
